import { combineReducers, createStore } from "@reduxjs/toolkit";
import tagReducer from "redux/tag";
import courseReducer from "redux/course";
import userReducer from "redux/user";
import lessonReducer from "redux/lesson";
import paragraphReducer from "redux/lesson/paragraph";
import quizReducer from "redux/lesson/quiz";
import questionReducer from "redux/lesson/quiz/question";
import responseReducer from "redux/lesson/quiz/question/response";

export default createStore(
  combineReducers({
    user: userReducer,
    tag: tagReducer,
    course: courseReducer,
    lesson: lessonReducer,
    paragraph: paragraphReducer,
    quiz: quizReducer,
    question: questionReducer,
    response: responseReducer,
  })
);
